var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogsManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_1702)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 2.75,
    width: 21.5,
    height: 25.5,
    rx: 1.25,
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7H21.5M8 11H21.5M8 15H21.5M8 19H16.5",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 28C21 28.2761 20.7761 28.5 20.5 28.5C20.2239 28.5 20 28.2761 20 28C20 27.7239 20.2239 27.5 20.5 27.5C20.7761 27.5 21 27.7239 21 28Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4169 17.0106C15.4787 16.8309 15.5806 16.6677 15.715 16.5334L26.9503 5.2981C27.6337 4.61468 28.7417 4.61468 29.4251 5.2981C30.1086 5.98151 30.1086 7.08955 29.4251 7.77297L18.1896 19.0085C18.0554 19.1427 17.8923 19.2446 17.7128 19.3065L14.6966 20.3451C14.4997 20.4129 14.3111 20.2243 14.3788 20.0274L15.4169 17.0106L14.7077 16.7666L15.4169 17.0106Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_1702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsManagementIcon);
export default __webpack_public_path__ + "static/media/blogs-management-icon.80743d41033629fd39cc88ab89722719.svg";
export { ForwardRef as ReactComponent };